import { ICatalogManager } from '../../models/Common/ICatalog-manager';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { lastValueFrom } from '../../helpers/functions.helpers';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LinkupService {
    /**
     * @todo documentar
     */
    public _catalogSettings: ICatalogManager | any;
    private _settings: any;
    private _contextUrls: any;
    private _applicationParameters: any;
    private _analytics: any;
    private _urlSettings = './assets/resources/settings.json';
    private _urlContextUrls = './assets/resources/context.urls.json';
    private _urlApplicationParameters = './assets/resources/application_parameters.json';
    private _urlAnalyticsData = './assets/analytics/analytics-data.json';
    /**
     * Constructor de la clase LinkupService
     * @param _http
     */
    constructor(
        private _http: HttpClient
    ) { }

    /**
     * Permite establecer el valor a _catalogSettings
     */
    set catalogSettings(value: any) {
        this._catalogSettings = value;
    }

    /**
     * Permite la carga de las listas estaticas desde el archivo settings.json
     */
    get catalogSettings(): Promise<any> {
        return new Promise(async (resolve, reject) => {
            if (!this._catalogSettings) {
                const settings: any = await this.settings;
                if (settings && settings.hasOwnProperty('request') && settings.request.hasOwnProperty('CATALOG_MANAGER_V1')) {
                    this.catalogSettings = { ...settings.request['CATALOG_MANAGER_V1'] };
                } else {
                    this.catalogSettings = undefined;
                }
                resolve(this._catalogSettings);
            } else {
                resolve(this._catalogSettings);
            }
        });
    }

    /**
     * Permite obtener el valor de configuracion del archivo settings
     */
    get settings(): Promise<any> {
        return new Promise(async (resolve, reject) => {
            if (!this._settings) {
                const URL = this._urlSettings;
                /**
                 * @see https://rxjs.dev/deprecations/to-promise
                 */
                const req$ = this._http.get(URL);
                const response: any = await lastValueFrom(req$);
                if (response) {
                    this.settings = response;
                }
                else {
                    this.settings = undefined;
                }
                resolve(this._settings);
            } else {
                resolve(this._settings);
            }
        });
    }

    /**
     * Permite establecer el valor a _settings
     */
    set settings(value: any) {
        this._settings = value;
    }

    get analytics(): Promise<any> {
        return new Promise(async (resolve, reject) => {
            const URL = this._urlAnalyticsData;
            /**
             * @see https://rxjs.dev/deprecations/to-promise
             */
            const req$ = this._http.get(URL);
            const response: any = await lastValueFrom(req$);
            if (response) {
                this.analytics = response;
            }
            else {
                this.analytics = undefined;
            }
            resolve(this._analytics);
        });
    }

    set analytics(value: any) {
        this._analytics = value;
    }

    /**
     * Permite obtener el valor de configuracion del archivo _contextUrls
     */
    get contextUrls(): Promise<any> {
        return new Promise(async (resolve, reject) => {
            if (!this._contextUrls) {
                const URL = this._urlContextUrls;
                const req$ = this._http.get(URL);
                const response: any = await lastValueFrom(req$);
                if (response) {
                    this.contextUrls = response;
                }
                else {
                    this.contextUrls = undefined;
                }
                resolve(this._contextUrls);
            } else {
                resolve(this._contextUrls);
            }
        });
    }

    /**
     * Permite establecer el valor a _contextUrls
     */
    set contextUrls(value: any) {
        this._contextUrls = value;
    }

    /**
     * Permite establecer el valor a _applicationParameters
     */
    set applicationParameters(value: any) {
        this._applicationParameters = value;
    }

    /**
     * Permite la carga de las listas estaticas desde el archivo application_parameters.json
     */
    get applicationParameters(): Promise<any> {
        return new Promise(async (resolve, reject) => {
            if (!this._applicationParameters) {
                const URL = this._urlApplicationParameters;
                const req$ = this._http.get(URL);
                const response: any = await lastValueFrom(req$);
                if (response) {
                    this.applicationParameters = response;
                }
                else {
                    this.applicationParameters = undefined;
                }
                resolve(this._applicationParameters);
            } else {
                resolve(this._applicationParameters);
            }
        });
    }

    asyncGet=async(URL:string):Promise<any>=>{
      let _rl = await lastValueFrom(this._http.get(URL,{ responseType: 'blob' }));
      let _rsp = Promise.resolve(_rl);
      return _rsp;
    }
}
